export function videoPopup() {
  let
    body = $('body'),
    commandPlay = {
      "event": "command",
      "func": "playVideo"
    };

  body.on('click', '.open-video', function (e) {
    e.preventDefault();

    let
      url = $(this).data('video-scr'),
      src = url +  (url.indexOf("?") > -1 ? "&" : "?") + 'autoplay=1&enablejsapi=1',
      popup = '<div class="video-popup">' +
        '<div class="popup-holder">' +
        '<span class="close"><s></s></span>' +
        '<iframe src="' + src + '" frameborder="0" frameborder="0" autoplay allow="autoplay; fullscreen" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>' +
        '</div>' +
        '</div>';

    body.addClass("popup-open").append(popup);

    setTimeout(() => {
      $('.video-popup').find('iframe')[0].contentWindow.postMessage(JSON.stringify(commandPlay), "*");
    }, 800);

  }).on('click', '.video-popup .close', function (e) {
    e.preventDefault();
    body.removeClass("popup-open");
    $('.video-popup').remove();
  });
}



// WEBPACK FOOTER //
// ./assets/js/modules/videoPopup.js